export default __webpack_public_path__ + "static/media/09-min.2eb16acb.jpg";